import { EntityType } from '~/enums/EntityType';
import { sylvanus } from '~/services/serviceInstances';
import { EntityQuery } from '~/types/OpenSearch';

import {
  PromptModelDocsInScope,
  PromptModelExternalEntity,
  SearchScope,
} from '../../types/sylvanus/model';
import { withQueryFormat } from './searchScopeUtils';

type SearchQuery = EntityQuery[];

export const getDocsInScope = async ({
  entityId,
  entityType,
  query,
  ufId,
}: {
  entityId: string;
  entityType: EntityType.Field | EntityType.DocumentAttachedData;
  query: SearchQuery;
  ufId?: string;
}): Promise<number> => {
  const scope: SearchScope = {
    data: {
      attributes: {
        filters: [],
        query: withQueryFormat(query),
        store_as_recent_search: false,
      },
    },
    type: 'document',
  };
  const target_entity: PromptModelExternalEntity = {
    id: entityId,
    type: entityType,
    ...(ufId ? { uf_id: ufId } : {}),
  };
  const response: PromptModelDocsInScope = await sylvanus.post(
    `/model/docs-in-scope`,
    {
      target_entity,
      scope,
    },
  );
  return response.docs_in_scope;
};
